export default __webpack_public_path__ + "static/ashok leyland-05726f73f7802112435a1fb0db62e08e.jpg";